import Seo from '@/components/feature/Seo';
import HomeHero from '@/pages/home/components/HomeHero';
import FocusSection from '@/pages/home/components/FocusSection';
import CategorySection from '@/pages/home/components/CategorySection';
import RecommendedSection from '@/pages/home/components/RecommendedSection';
import GroupHighlightSection from '@/pages/home/components/GroupHighlightSection';
import RankingSection from '@/pages/home/components/RankingSection';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaSection from '@/pages/home/components/CtaSection';
import { faqs, siteInfo } from '@/mocks/gossip';

export default function Home() {
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: siteInfo.name,
      url: typeof window !== 'undefined' ? window.location.origin : 'https://www.youhuochigua.com',
      description: siteInfo.description,
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${typeof window !== 'undefined' ? window.location.origin : ''}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteInfo.name,
      url: typeof window !== 'undefined' ? window.location.origin : 'https://www.youhuochigua.com',
      email: siteInfo.email,
      slogan: siteInfo.slogan,
      foundingDate: String(siteInfo.since),
      description: siteInfo.description,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="诱惑吃瓜 - 颜值美照｜生图红毯｜高光同框一次看个够"
        description="诱惑吃瓜专注颜值与视觉盛宴，美照生图、红毯造型、明星同框高光时刻全收录。想看谁的生图最能打、哪对同框最有火花，高清美图与红毯名场面一次看个够。"
        keywords="诱惑吃瓜,颜值美照,生图红毯,高光同框,红毯造型,明星同框,高光时刻"
        type="website"
        jsonLd={structuredData}
      />
      <HomeHero />
      <FocusSection />
      <CategorySection />
      <RecommendedSection />
      <GroupHighlightSection />
      <RankingSection />
      <TestimonialSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}